<template>
    <div class="index-main" :class="show_header">
        <mp-header></mp-header>
        <float-menu></float-menu>
        <!-- true code -->
        <template v-for="comp in comp_list">
            <!-- 图片组件 -->
            <template v-if="comp.type == 13">
                <v-image :key="comp.id" :data="comp.data" :target="comp.targetId"
                :findex="comp.findex" @mounted="componentMounted" @focus_slide="onFocusSlide" :spm = "comp.spm"></v-image>
            </template>
            <!-- 焦点图组件 -->
            <template v-else-if="comp.type == 7">
                <focus :key="comp.id" 
                    :data="comp.data" 
                    :target="comp.targetId"
                    :findex="comp.findex" 
                    :tag="comp.tag"
                    @mounted="componentMounted" 
                    :spm = "comp.spm"></focus>
            </template>
            <!-- 栏目组件（文章列表） -->
            <template v-else-if="comp.type == 15">
                <column :key="comp.id" :param="comp" :target="comp.targetId"
                :findex="comp.findex" @mounted="componentMounted" :spm = "comp.spm"></column>
            </template>
            <!-- 文本组件 -->
            <template v-else-if="comp.type == 14">
                <v-text :key="comp.id" :data="comp.data" :target="comp.targetId"
                :findex="comp.findex" @mounted="componentMounted"></v-text>
            </template>
            <!-- 视频组件(直播、千帆、搜狐视频) -->
            <template v-else-if="comp.type == 10">
                <v-video :key="comp.id" :data="comp.data" :target="comp.targetId"
                :findex="comp.findex" @mounted="componentMounted" :spm = "comp.spm"></v-video>
            </template>
            <!-- 导航内链组件 -->
            <template v-else-if="comp.status==1 && comp.type == 18">
                <v-nav-inner :key="comp.id"
                    :data="comp.data"
                    :target="comp.targetId"
                    :findex="comp.findex"
                    :spm="comp.spm">
                </v-nav-inner>
            </template>
            <!-- 外链组件 -->
            <template v-else-if="comp.type == 17">
                <v-outer-link :key="comp.id"
                    :data="comp.data"
                    :target="comp.targetId"
                    :findex="comp.findex"
                    :spm="comp.spm"
                    @mounted="componentMounted">
                </v-outer-link>
            </template>
            <!-- 四图组件 -->
            <template v-else-if="comp.type == 19">
                <four-pics :key="comp.id"
                    :data="comp.data"
                    :target="comp.targetId"
                    :tag="comp.tag"
                    :spm="comp.spm">
                </four-pics>
            </template>
            <!-- 五图组件 -->
            <template v-else-if="comp.type == 20">
                <five-pics :key="comp.id"
                    :data="comp.data"
                    :target="comp.targetId"
                    :tag="comp.tag"
                    :spm="comp.spm">
                </five-pics>
            </template>
            <template v-else-if="comp.type == 22">
                <focus-news :key="comp.id"
                    :data="comp.data"
                    :tag="comp.tag"
                    :spmLeft="comp.spmLeft"
                    :spmRight="comp.spmRight">
                </focus-news>
            </template>
        </template>

        <!-- 评论组件 -->
        <!-- <template v-if="subData.hasComment == 1">
            <v-comment :sub_id="subData.id"></v-comment>
        </template> -->
        <!-- 底部浮层推广位 -->
        <!-- <float-promo></float-promo> -->
    </div>
</template>
<script>
import $ from 'jquery';
import Vue from 'vue';
Vue.silent = true;
import ContentEvStat from './statistics/content-ev-stat';
import InnerNavStat from './statistics/inner-nav-stat';
import ShareWechat from './_utils/share-wechat';

const subData = typeof window !== 'undefined' ? window.subData : {};
export default {
    data (){
        return {
            subData: {},
            dynamicComponents: [],
        }
    },
    methods: {
        addExpose(contentList) {
            ContentEvStat.addContentEv(contentList);
            this.allExposureCheck();
        },
        allExposureCheck() {
            ContentEvStat.allExposureCheck();
        },
        componentMounted(list){
            this.addExpose(list);
        },
        innerNavMounted(list){
            InnerNavStat.init(list);
        },
        onFocusSlide(){
            this.allExposureCheck();
        }
    },
    created(){
        this.dynamicComponents = subData.dynamicComponents || [];
        this.subData = subData || {};
    },
    mounted(){
        // 初始化曝光统计
        var exposeContentList = document.querySelectorAll('a[data-log-content-ev]');
        ContentEvStat.init(exposeContentList);
        const shareData = {
            title: document.title,
            link: window.location.href,
            desc: window.location.href,
            imgUrl: 'http://sohu-media.bjcnc.scs.sohucs.com/web/static/images/sohu-logo.png',
        };
        ShareWechat(shareData);
    },
    components: {
        MpHeader: () => import('@/components/MpHeader'),
        VImage: () => import('@/components/VImage'),
        Focus: () => import('@/components/Focus'),
        Column: () => import('@/components/Column'),
        VText: () => import('@/components/VText'),
        VVideo: () => import('@/components/VVideo'),
        VNavInner: () => import('@/components/VNavInner'),
        VOuterLink: () => import('@/components/VOuterLink'),
        VComment: () => import('@/components/VComment'),
        FloatMenu: () => import('@/components/FloatMenu'),
        FloatPromo: () => import('@/components/FloatPromo'),
        FourPics: () => import('@/components/FourPics'),
        FivePics: () => import('@/components/FivePics'),
        FocusNews: () => import('@/components/FocusNews'),
    },
    computed: {
        comp_list(){
            let tmpArr, findex, type, typeIndex, spm;
            this.dynamicComponents.forEach(function(comp, index){
                tmpArr = comp.name.split('_');
                comp.findex = tmpArr[1];
                type = comp.code;
                typeIndex = tmpArr[1];
                comp.spm = `${type}-${typeIndex}`;
                if (comp.type === 22) {
                    comp.spmLeft = `mix_pic-${typeIndex}`;
                    comp.spmRight = `mix_news-${typeIndex}`;
                }
            });
            return this.dynamicComponents;
        },
        show_header(){
            return window.subData.hasHeader ? '' : window.subData.hasHeaderBlank ? 'forappOld': 'forappNew';
        }
    }
}
</script>
<style lang="less">
@import './assets/style/reset.less';
@import './assets/style/common.less';
@import './assets/style/border-1px.less';
.rb-b{
    border-width: 0 0 1px 0;/*no*/
    border-bottom-style: solid;
    border-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='3' height='3'%3E%3Crect fill='transparent' stroke='%23e3e3e3' width='3' height='3'/%3E%3C/svg%3E") 1 1 1 1 round;/*no*/
}
.rb-t{
    border-width: 1px 0 0 0;/*no*/
    border-bottom-style: solid;
    border-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='3' height='3'%3E%3Crect fill='transparent' stroke='%23e3e3e3' width='3' height='3'/%3E%3C/svg%3E") 1 1 1 1 round;/*no*/
}
.rb-all{
    border: 1px solid;/*no*/
    border-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='3' height='3'%3E%3Crect fill='transparent' stroke='%23e3e3e3' width='3' height='3'/%3E%3C/svg%3E") 1 1 1 1 round;/*no*/
}
.index-main{
    background: #ffffff;
    padding-bottom: 20px;
    padding-top: 44px;/*no*/
    &.forappNew{
        padding-top: 0;
    }
    &.forappOld{
        padding-top: 44px;/*no*/
    }
}
</style>



// WEBPACK FOOTER //
// src/Subject.vue